/* eslint-disable */
import { errorMsg, customErrorMsg } from '../constants/messages';
import { REGEX_PHONE_NUMBER } from '../utils/Regexp/Regex';
import { COUNTRY } from '../constants/EntityName';

const documitraPartnersFormData = [
  {
    title: 'Agent Information',
    name: 'partnerId',
    label: 'Agent ID',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Agent ID', allowAddRecordClick: true, columnType: 'partnerIdSeries' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    readonly: true,
    hideInCreate: true,
    useSidebarLayoutInAccordion: true,
    sidebarField: true,
    useReadonlyCard: true,
  },
  {
    name: 'partnerName',
    label: 'Agent Name',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Agent Name', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    editReadOnly: true,
    sidebarField: true,
  },
  {
    name: 'companyName',
    label: 'Company Name',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Company Name' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    editReadOnly: true,
    sidebarField: true,
  },
  {
    name: 'originCountry',
    label: 'Country Name',
    fieldType: {
      name: 'select',
      options: [],
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Country Name' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    editReadOnly: true,
    sidebarField: true,
  },
  {
    name: 'contactPerson',
    label: 'Contact Person',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Contact Person', allowAddRecordClick: true },
    isTableHeader: false,
    isAccordian: true,
    default: '',
    editReadOnly: true,
    sidebarField: true,
  },
  {
    name: 'email',
    label: 'Email ID',
    fieldType: {
      name: 'email',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Email ID' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    editReadOnly: true,
    sidebarField: true,
  },
  {
    name: 'contactNumber',
    label: 'Mobile Number',
    fieldType: {
      name: 'phoneWithCountryCode',
    },
    required: true,
    rules: [{ pattern: REGEX_PHONE_NUMBER, message: customErrorMsg('phone number') }],
    errorMsg: errorMsg,
    tableMeta: { title: 'Contact Number' },
    isTableHeader: false,
    isAccordian: true,
    default: '',
    placeholder: 'Enter mobile number',
    editReadOnly: true,
    sidebarField: true,
  },

  {
    name: 'createdAt',
    label: 'Joined',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Joined' },
    isTableHeader: true,
    isAccordian: false,
    default: '',
  },

  // {
  //   name: 'actions',
  //   label: 'Actions',
  //   fieldType: {
  //     name: 'text',
  //   },
  //   required: false,
  //   errorMsg: errorMsg,
  //   tableMeta: { title: 'Actions', columnType: 'actions' },
  //   isTableHeader: true,
  //   isAccordian: false,
  //   default: '',
  // },
  {
    name: 'addressLine1',
    label: 'Address Line 1',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Address Line 1', allowAddRecordClick: false },
    isTableHeader: false,
    isAccordian: true,
    default: '',
  },
  {
    name: 'addressLine2',
    label: 'Address Line 2',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Address Line 2', allowAddRecordClick: false },
    isTableHeader: false,
    isAccordian: true,
    default: '',
  },
  {
    name: 'city',
    label: 'City',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'City', allowAddRecordClick: false },
    isTableHeader: false,
    isAccordian: true,
    default: '',
  },
  {
    name: 'state',
    label: 'State',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'State', allowAddRecordClick: false },
    isTableHeader: false,
    isAccordian: true,
    default: '',
  },
  {
    name: 'addressCountry',
    label: 'Country',
    fieldType: {
      name: 'select',
      options: [],
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Country', allowAddRecordClick: false },
    isTableHeader: false,
    isAccordian: true,
    default: '',
  },
  {
    name: 'zipCode',
    label: 'Zip/Postal Code',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Zip Code', allowAddRecordClick: false },
    isTableHeader: false,
    isAccordian: true,
    default: '',
  },
  {
    name: 'status',
    label: 'Active',
    fieldType: {
      name: 'radio',
      options: [
        { label: 'Active', value: 'Active' },
        { label: 'Inactive', value: 'Inactive' },
      ],
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Status', columnType: 'status' },
    isTableHeader: true,
    isAccordian: true,
    default: 'Active',
  },
  {
    name: 'zelleId',
    label: 'Zelle ID',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Zelle ID', allowAddRecordClick: false },
    isTableHeader: false,
    isAccordian: true,
    default: '',
    forceGridRowStart: true,
    sectionDividerBefore: true,
  },
  {
    name: 'venmoId',
    label: 'Venmo ID',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Venmo ID', allowAddRecordClick: false },
    isTableHeader: false,
    isAccordian: true,
    default: '',
  },
  {
    name: 'upiId',
    label: 'UPI ID',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'UPI ID', allowAddRecordClick: false },
    isTableHeader: false,
    isAccordian: true,
    default: '',
  },
];

export { documitraPartnersFormData };
